import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {API_URL} from '../services/token.service';
import 'rxjs/add/operator/toPromise';

@Injectable()

export class _RuleCurrencyCrossService {

  constructor(private http: HttpClient) { }

  GetRuleCurrencyCross(){
    return this.http.get<any[]>(`${API_URL}/rule-currency-crosses`).toPromise().then((result) => {
      return result;
    });
  }

  CreateRuleCurrencyCross(currencyCross){
    return this.http.post<any>(`${API_URL}/rule-currency-crosses`, [ currencyCross ]).toPromise().then((result) => {
      return result;
    });
  }

  UpdateRuleCurrencyCross(currencyCross){
    return this.http.put<any>(`${API_URL}/rule-currency-crosses`, [ currencyCross ]).toPromise().then((result) => {
      return result;
    });
  }

  DeleteRuleCurrencyCross(currencyCrossId){
    return this.http.delete<any>(`${API_URL}/rule-currency-crosses/` + currencyCrossId).toPromise().then((result) => {
      return result;
    });
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/ng1-services/rule-currency-cross.service.ts